<div class="fancy-hero-one coutom_header">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 m-auto hdr_with_btn">
          <a class="back_wrap" routerLink="/user-property-list"><img src="assets/images/assets/back.png" alt="Back" title="Back" /></a>
          <h3 class="font-rubik">{{name}} ({{mobile_no}})</h3> 
          <a class="logout_wrap" (click)="logout()"><img  src="assets/images/assets/logout.png" alt="Logout" title="Logout" /></a>
          <button class="hdr_btn theme-btn-six" [routerLink]="['/register-property']">Add New Asset</button>
        </div>
      </div>
    </div>
  </div>

  <div class="coutom_two">
    <div class="container">
    <div class="top-border pb-50 md-pb-50">
        <div class="controls po-control-one text-center mb-50 md-mb-50 mt-50 md-mt-60">
          <button type="button" class="control" [ngClass]="isActive === 'payment_history' ? 'active' : ''"
            (click)="handleItem('payment_history')">Payment History</button>
          <button type="button" class="control" [ngClass]="isActive === 'payment_ledger' ? 'active' : ''"
            (click)="handleItem('payment_ledger')">Ledger Detail</button>
        </div>


        <div *ngIf="payment_history">
            <div class="pb-50">
                  <div class="table_wrap">
                    
                    <table *ngIf="paymentHistory.length > 0" class="table table_design">
                      <thead>
                        <tr>
                          <th scope="col">Date</th>
                          <th scope="col">Payment Mode</th>
                          <th scope="col">Transaction ID</th>
                          <th scope="col">Amount</th>
                          <th scope="col">Payment Status</th>
                          <th class="text-center" scope="col">Receipt</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let data of paymentHistory; index as i">
                          <td scope="row">{{data?.payment_date | date : 'dd/MM/YYYY'}}</td>
                          <td class="capitalize" scope="row">{{ data?.mode_of_payment }}</td>
                          <td>{{ data?.trx_id}}</td>
                          <td><span *ngIf="data?.amount >= 0">{{ data?.amount | currency:'INR'}}</span></td>
                          <td class="capitalize">{{ data?.payment_status}}</td>
                          <td  class="text-center"><a *ngIf="data?.payment_receipt" target="_blank" (click)="downloadReceipt(data.payment_receipt)">
                            <img style="max-width: 18px;" src="assets/images/assets/download.png" alt="Download" title="Download" /></a></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
            </div>
        </div>
        <div *ngIf="payment_ledger">
            <div class="pb-50">
                <div class="table_wrap">
                
                <table *ngIf="paymentLedger.length > 0" class="table table_design">
                    <thead>
                    <tr>
                        <th scope="col">Date</th>
                        <th scope="col">Transaction Type</th>
                        <th scope="col">Amount</th>
                        <th scope="col">Balance</th>
                        <th scope="col">Description</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let data of paymentLedger; index as i">
                        <td>{{data?.date | date : 'dd/MM/YYYY'}}</td>
                        <td class="capitalize">{{ data?.transection_type }}</td>
                        <td><span *ngIf="data?.amount >= 0">{{ data?.amount | currency:'INR'}}</span></td>
                        <td><span *ngIf="data?.balance >= 0">{{ data?.balance | currency:'INR'}}</span></td>
                        <td>{{ data?.description}}</td>
                    </tr>
                    </tbody>
                </table>
                </div>
            </div>
        </div>
  </div>
    </div>
  </div>